import { SliderDrag as SliderDragCore } from '@studiometa/ui';
import { addClass, removeClass } from '@studiometa/js-toolkit/utils';

/**
 * SliderDrag component
 */
export default class SliderDrag extends SliderDragCore {
  /**
   * Listen to the `mousedown` event.
   */
  onMousedown() {
    addClass(document.documentElement, 'is-grabbing');

    document.addEventListener(
      'mouseup',
      () => {
        removeClass(document.documentElement, 'is-grabbing');
      },
      { once: true },
    );
  }

  /**
   * Add the `cursor-grab` class to the element.
   */
  mounted() {
    addClass(this.$el, 'cursor-grab');
  }

  /**
   * Remove the `cursor-grab` class from the element.
   */
  destroyed() {
    removeClass(this.$el, 'cursor-grab');
  }
}
